import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { Button } from '@/components/ui/button';
import { reportError } from '@/lib/sentry';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * Écran d'une erreur de rendu ou de chargement (errorElement de la route racine), à la place de celui de React Router.
 * React Router attrape l'erreur : elle n'arriverait pas seule jusqu'à Sentry, elle lui est donc signalée ici.
 */
export function ErrorPage() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;

  useEffect(() => {
    if (!notFound) reportError(error);
  }, [error, notFound]);

  if (notFound) return <NotFoundPage />;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 text-slate-600">
      <h1 className="text-2xl font-bold text-slate-900">Une erreur est survenue</h1>
      <p>Rechargez la page. Si le problème persiste, contactez votre administrateur.</p>
      <div className="flex items-center gap-4">
        <Button onClick={() => window.location.reload()}>Recharger la page</Button>
        {/* Lien classique : l'appli repart de zéro */}
        <a href="/" className="text-blue-600 hover:underline">
          Retour à l'accueil
        </a>
      </div>
    </div>
  );
}
